import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Affected' })((theme) => ({
    affected: {
        marginTop: 46
    },
    tabComponent: {
        border: '1px solid #E0E0E0',
        padding: '10px 20px',
        borderRadius: 18
    },
    tabs: {},
    indicator: {
        display: 'none'
    },
    tab: {
        fontSize: 24,
        fontWeight: 700,
        textTransform: 'initial'
    },
    tabAlone: {
        fontSize: 24,
        fontWeight: 700,
        fontColor: theme.palette.default.main,
        textTransform: 'initial'
    }
}));
